import { render, staticRenderFns } from "./platformCouponUseLog.vue?vue&type=template&id=60713df6&scoped=true"
import script from "./platformCouponUseLog.vue?vue&type=script&lang=js"
export * from "./platformCouponUseLog.vue?vue&type=script&lang=js"
import style0 from "./platformCouponUseLog.vue?vue&type=style&index=0&id=60713df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60713df6",
  null
  
)

export default component.exports